export const RedirectIds = {
    DEFAULT_WORKSPACE: 'default_workspace',
};
